export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_03.354d4210.jpg";